import { z } from "zod";
import { parse } from "./index.js";
export function parseRoot(Content, Schema, props = {}) {
    const data = parse(Content, props || {});
    if (Schema) {
        return parseProps(data, Schema);
    }
    return data;
}
export const Block = z.object({
    title: z.string().optional(),
    children: z.custom(),
});
export const CodeBlock = z.object({
    meta: z.string(),
    value: z.string(),
    lang: z.string(),
});
export const HighlightedCodeBlock = CodeBlock.extend({
    code: z.string(),
    tokens: z.custom(),
    annotations: z.custom(),
    themeName: z.string(),
    style: z.custom(),
});
export const ImageBlock = z.object({
    url: z.string(),
    alt: z.string(),
    title: z.string(),
});
export function parseProps(content, Schema) {
    var _a;
    if (content === null || content === void 0 ? void 0 : content.__hike) {
        throw new Error("Code Hike Error: can't parse component content. Looks like you are missing CodeHike's recma plugin or the framework you are using doesn't support it.");
    }
    const result = Schema.safeParse(content);
    if (result.success) {
        return result.data;
    }
    const error = result.error.errors[0];
    let p = error.path.slice();
    let block = content;
    let location = "";
    while (p.length) {
        const key = p.shift();
        block = block[key];
        if ((_a = block === null || block === void 0 ? void 0 : block._data) === null || _a === void 0 ? void 0 : _a.header) {
            location += `\n${block._data.header}`;
        }
    }
    const { path, code, message, ...rest } = error;
    const name = path[path.length - 1];
    throw new Error(`at ${location || "root"}
Error for \`${name}\`: ${message}
${JSON.stringify(rest, null, 2)}
  `);
}
